import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef, useContext } from 'react';
import { useUncontrolled } from 'uncontrollable';
import classnames from 'classnames';
import SelectableContext, { makeEventKey } from '../SelectableContext';
import TabContext from '../Tabs/TabContext';
import NavContext from './NavContext';
// eslint-disable-next-line 
const noop = ()=>{};
export const Nav = /*#__PURE__*/ forwardRef((props, ref)=>{
    const { className, children, componentClass: Component = 'ul', bsStyle, fill, justify, stacked, activeKey: activeKeyProp, onSelect, role: roleProp, ...rest } = useUncontrolled(props, {
        activeKey: 'onSelect'
    });
    // TODO: Hantera input med pil upp/ner på samma sätt som react-bootstrap
    const parentOnSelect = useContext(SelectableContext);
    const tabContext = useContext(TabContext);
    let getControlledId, getControllerId;
    let role = roleProp;
    let activeKey = activeKeyProp;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const bsClass = classnames('nav', className, {
        'nav-tabs': bsStyle === 'tabs'
    }, {
        'nav-pills': bsStyle === 'pills'
    }, {
        'nav-tabs nav-tabs-rr': bsStyle === 'rr-tabs'
    }, {
        'nav-tabs nav-tabs-rr-status': bsStyle === 'rr-status-tabs'
    }, {
        'nav-fill': !!fill
    }, {
        'nav-justified': !!justify
    }, {
        'flex-column': stacked
    });
    const handleSelect = (eventKey, e)=>{
        // eslint-disable-next-line eqeqeq
        if (eventKey == null) return;
        if (onSelect) onSelect(eventKey, e);
        if (parentOnSelect) parentOnSelect(eventKey, e);
    };
    return /*#__PURE__*/ _jsx(SelectableContext.Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ _jsx(NavContext.Provider, {
            value: {
                role,
                activeKey: makeEventKey(activeKey),
                getControlledId: getControlledId || noop,
                getControllerId: getControllerId || noop
            },
            children: /*#__PURE__*/ _jsx(Component, {
                ...rest,
                ref: ref,
                className: bsClass,
                children: children
            })
        })
    });
});
Nav.displayName = 'Nav';
